export const WarningOptionTypeEnum = {
  DISORDER: 'DISORDER',
  MAINTENANCE: 'MAINTENANCE'
};
